import { useParams } from "react-router-dom";
import { useRewardWithId } from "../rewards/useRewardWithId";

export const usePublicReward = () => {
  const { rewardId } = useParams<{ rewardId: string }>();
  const { data, isLoading } = useRewardWithId(rewardId);

  return {
    reward: data,
    isLoading,
  };
};
